import { DiAngularSimple, DiApple, DiChrome, DiFirefox, DiGit, DiLinux, DiNodejsSmall, DiNpm, DiReact, DiVisualstudio, DiWindows } from 'react-icons/di';
import { useTranslation } from 'react-i18next';
import { useRef, useState, useEffect } from 'react';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';

import HistoryCard from '../../components/historyCard/historyCard';
import meImg from '../../imgs/dwain.jpg'

import './me.scss'

function Me() {
  const { t } = useTranslation()
  const contentRef = useRef<HTMLDivElement>(null)
  const [showTopArrow, setShowTopArrow] = useState(false)
  const [showBottomArrow, setShowBottomArrow] = useState(false)

  useEffect(() => {
    document.title = 'About Me | Dwain'
  }, [])

  const checkScroll = () => {
    if (!contentRef.current) return

    const { scrollTop, scrollHeight, clientHeight } = contentRef.current
    const isScrollable = scrollHeight > clientHeight

    setShowTopArrow(scrollTop > 20)
    setShowBottomArrow(isScrollable && scrollTop < scrollHeight - clientHeight - 20)
  }

  useEffect(() => {
    const element = contentRef.current
    if (!element) return

    // Initial check
    const initialCheck = () => {
      checkScroll()
    }

    // Check nach Render und nach einem kurzen Delay
    initialCheck()
    setTimeout(initialCheck, 100)
    setTimeout(initialCheck, 300)

    element.addEventListener('scroll', checkScroll)
    window.addEventListener('resize', checkScroll)

    return () => {
      element.removeEventListener('scroll', checkScroll)
      window.removeEventListener('resize', checkScroll)
    }
  }, [])

  const scrollTo = (direction: 'up' | 'down') => {
    if (!contentRef.current) return

    const scrollAmount = 300
    const currentScroll = contentRef.current.scrollTop

    contentRef.current.scrollTo({
      top: direction === 'up' ? currentScroll - scrollAmount : currentScroll + scrollAmount,
      behavior: 'smooth'
    })
  }
  
  return (
    <main className='page-me'>

      <div className='me-content'>

        <aside className='content-about'>
          <header className='about-header'>
            <h1 className='header-name'>Dwain Reinert</h1>
            <p className='header-title'>Senior Fullstack Developer</p>
            <div>
              <div className='header-img'><img src={meImg} alt='Dwain Reinert - Senior Fullstack Developer'/></div>
            </div>
          </header>

          <nav className='about-use' aria-label="Technologies and Tools">
            <div>
              <DiVisualstudio aria-label="Visual Studio" />
            </div>
            <div>
              <DiNpm aria-label="NPM" />
              <DiGit aria-label="Git" />
            </div>
            <div>
              <DiChrome aria-label="Chrome" />
              <DiFirefox aria-label="Firefox" />
            </div>
            <div>
              <DiNodejsSmall aria-label="Node.js" />
              <DiReact aria-label="React" />
              <DiAngularSimple aria-label="Angular" />
            </div>
            <div>
              <DiWindows aria-label="Windows" />
              <DiLinux aria-label="Linux" />
              <DiApple aria-label="Apple" />
            </div>
          </nav>
        </aside>

        <article className='content-me' ref={contentRef}>
          <div className='scroll-indicators'>
            {showTopArrow && (
              <button className='scroll-arrow scroll-arrow-top' onClick={() => scrollTo('up')} aria-label="Scroll up">
                <FaChevronUp />
              </button>
            )}
          </div>

          <section className='me-info'>
            {t('me.infoText1')}
            <br/>
            <br/>
            {t('me.infoText2')}
            <br/>
            <br/>
            {t('me.infoText3')}
            <br/>
            <br/>
            {t('me.infoText4')}
            <br/>
            <br/>
            {t('me.infoText5')}
          </section>

          <section className='me-history' aria-label="Work History">
            <HistoryCard
              fromTo={'2026 - ' + t('general.now')}
              position={t('me.card.2026.position')}
              url='MyGrowbook.de'
              text={t('me.card.2026.text')}
              devTypes={['reactnative', 'react', 'typescript', 'android', 'nestjs', 'postgresql', 'redis', 'socketio', 'awss3', 'docker']}
            />

            <HistoryCard
              fromTo={'2018 - ' + t('general.now')}
              position={t('me.card.2018.position')}
              url='Soccerwatch.tv / Staige.tv'
              text={t('me.card.2018.text')}
              devTypes={['javascript', 'typescript', 'node', 'react', 'angular', 'html', 'css', 'scss','googlecloud']}
            />

            <HistoryCard
              fromTo='2016 - 2018'
              position={t('me.card.2016.position')}
              url='sandboxer.de'
              text={t('me.card.2016.text')}
              devTypes={[ 'wordpress', 'html', 'scss' ]}
            />

            <HistoryCard
              fromTo='2013 - 2020'
              position={t('me.card.2013.position')}
              url='BlackDesert-Online.de'
              text={t('me.card.2013.text')}
              devTypes={[ 'wordpress', 'html', 'css' ]}
            />

            <HistoryCard
              fromTo='2011 - 2019'
              position={t('me.card.2011.position')}
              url='ArcheAge-Online.de'
              text={t('me.card.2011.text')}
              devTypes={[ 'joomla', 'html', 'css' ]}
            />
          </section>

          <div className='scroll-indicators'>
            {showBottomArrow && (
              <button className='scroll-arrow scroll-arrow-bottom' onClick={() => scrollTo('down')} aria-label="Scroll down">
                <FaChevronDown />
              </button>
            )}
          </div>
        </article>
      </div>
    </main>
  )
}

export default Me
